module.exports = __webpack_public_path__ + "static/media/downloads_page.1ac83540.png";